import React, { useState } from "react";
import { ReactComponent as Diamond } from "../../svgs/diamond.svg";
import { ReactComponent as Circle } from "../../svgs/circle.svg";
import { ReactComponent as Copy } from "../../svgs/copy.svg";
import { ReactComponent as Tick } from "../../svgs/tick.svg";
import getSymbolFromCurrency from "currency-symbol-map";
import { useSelector } from "react-redux";
import Button from "../../atoms/Button";
import { formatBalance } from "../../../utils/helper/wallet";

const Arrow = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={29}
      height={30}
      className={className}
      viewBox="0 0 29 30"
      fill="none"
    >
      <g clipPath="url(#clip0_3_25163)">
        <path
          d="M14.5 20.8926L14.5 9.10744"
          stroke="white"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.60742 15L14.5 9.10744L20.3925 15"
          stroke="white"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_25163">
          <rect
            width={20}
            height={20}
            fill="white"
            transform="translate(0.35791 15) rotate(-45)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const WalletCard = ({ onWithdraw, onAdd, walletData }) => {
  const { balance, wallet_id, currency, settled_amount, unsettled_amount } =
    walletData;

  const { userType } = useSelector((state) => state.authReducer);
  const [isCopied, setIsCopied] = useState(false);
  return (
    <div
      className="w-[calc(100%/3)] h-[250px] bg-blue-gradient rounded-xl p-4 text-white wallet-card relative"
      style={{ boxShadow: "0px 24px 24px -18px rgba(0, 84, 180, 0.51)" }}
    >
      <Diamond className="absolute opacity-10 top-6 right-0" />
      <div className="options cursor-pointer absolute right-3 top-3 flex flex-col gap-y-1">
        <Circle className="w-5 h-5" />
      </div>
      <p className="text-base font-bold capitalize">{userType} Wallet</p>
      <div className="flex">
        <p className="w-[6.8rem] truncate text-xs mt-1">{wallet_id}</p>
        <div
          className="self-center cursor-pointer"
          onClick={() => {
            navigator.clipboard.writeText("wallet_id");
            setIsCopied(true);
            setTimeout(() => {
              setIsCopied(false);
            }, 300);
          }}
        >
          {!isCopied ? <Copy className="w-3" /> : <Tick className="w-5" />}
        </div>
      </div>
      <p className="text-[1.75rem] font-extrabold mt-4">
        $ {formatBalance(balance)}
      </p>
      <div className="flex justify-between mt-2.5 gap-x-3">
        {/* <div className="w-1/2">
          <p className="text-base font-bold">Settled Amount</p>
          <p className="text-xs font-normal">
            {getSymbolFromCurrency(currency)} 
           $ {formatBalance(settled_amount)}
          </p>
        </div> */}
        <div className="w-1/2">
          <p className="text-base font-bold">Unsettled Amount</p>
          <p className="text-xs font-normal">
            {/* {getSymbolFromCurrency(currency)}  */}
            $ {formatBalance(unsettled_amount)}
          </p>
        </div>
      </div>
      <div className="flex justify-between gap-x-3 mt-5">
        {userType !== "seller" && (
          <Button
            style={{ background: "rgba(255, 255, 255, 0.16)" }}
            className={
              "w-1/2 rounded-md text-[14px] backdrop-blur-[2px] h-[40px] px-6 py-3 bg-red-100 flex justify-center items-center"
            }
            onClick={onAdd}
          >
            Add Money <Arrow />
          </Button>
        )}
        <Button
          style={{ background: "rgba(255, 255, 255, 0.16)" }}
          className={
            "w-1/2 rounded-md text-[14px] backdrop-blur-[2px] h-[40px] px-6 py-3 bg-red-100 flex justify-center items-center"
          }
          onClick={onWithdraw}
        >
          Withdraw
          <Arrow className={"rotate-180"} />
        </Button>
      </div>
    </div>
  );
};

export default WalletCard;
